import React from 'react';
import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="min-h-screen flex">
      {/* Left dark panel — white logo is visible here */}
      <div className="hidden lg:flex lg:w-[45%] relative bg-[#ffffff] flex-col items-center justify-center overflow-hidden">
        {/* Ambient orange glow */}
        <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-primary/20 blur-3xl pointer-events-none" />
        <div className="absolute -bottom-32 -right-32 w-[500px] h-[500px] rounded-full bg-[#7C3AED]/15 blur-3xl pointer-events-none" />

        {/* Decorative rings */}
        <div className="absolute top-1/4 right-10 w-36 h-36 rounded-full border border-primary/20" />
        <div className="absolute top-1/4 right-10 w-24 h-24 rounded-full border border-primary/10 translate-x-6 translate-y-6" />
        <div className="absolute bottom-1/4 left-10 w-24 h-24 rounded-full border border-primary/25" />

        {/* Brand content */}
        <div className="relative z-10 flex flex-col items-center gap-6 px-14 text-center">
          <img src="/images/login/logo.png" alt="logo" className="max-w-52 w-full" />
        </div>
      </div>

      {/* Right white panel — login form */}
      <div className="flex-1 flex flex-col justify-center items-center bg-white relative overflow-hidden px-8 py-12">
        {/* Mobile logo */}
        <div className="lg:hidden absolute top-6 left-6 bg-[#ffffff] p-2 rounded-lg">
          <img src="/images/login/logo.png" alt="logo" className="max-w-24 w-full" />
        </div>

        {/* Subtle corner accent */}
        <div className="absolute top-0 right-0 w-56 h-56 rounded-bl-full bg-primary/5 pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-40 h-40 rounded-tr-full bg-primary/5 pointer-events-none" />

        <div className="w-full max-w-md relative z-10">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
